import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import img1 from "../assets/profile.png";
import img2 from "../assets/gold-verified-1.png";
import './TechnicianSlider.css';
import Api from "../Api";

const TechnicianSlider = () => {
  const sliderRef = useRef(null);
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    fetchTechnicians();
  }, []);

  useEffect(() => {
    const updateSliderLayout = () => {
      const width = window.innerWidth;
      setIsMobileView(width <= 768);
      setSlidesToShow(width <= 768 ? 1 : width < 1024 ? 3 : 4);
      setCurrentIndex(0);
      if (sliderRef.current) sliderRef.current.scrollLeft = 0;
    };

    updateSliderLayout();
    window.addEventListener('resize', updateSliderLayout);
    return () => window.removeEventListener('resize', updateSliderLayout);
  }, []);

  const fetchTechnicians = async () => {
    try {
      setLoading(true);
      setError(null);

const response = await Api.get('/api/web/get-all-technicians', {
  headers: {
    Accept: 'application/json',
  },
});



      const data = await response.data;

      if (data.success) {
        const formattedTechnicians = data.data.map(tech => {
          // Extract category names and their subcategories
          let categoryDisplay = 'Professional Services';
          let categoryArray = [];
          let subcategoryArray = [];
          let fullCategoryInfo = [];

          if (tech.categories && Array.isArray(tech.categories) && tech.categories.length > 0) {
            tech.categories.forEach(cat => {
              // Add category name
              if (cat.categoryName) {
                categoryArray.push(cat.categoryName);
              }
              
              // Extract subcategories
              if (cat.subcategories && Array.isArray(cat.subcategories)) {
                cat.subcategories.forEach(subcat => {
                  if (subcat.subCategoryName) {
                    subcategoryArray.push(subcat.subCategoryName);
                  }
                });
              }
              
              // Store full category info including subcategories
              fullCategoryInfo.push({
                categoryName: cat.categoryName,
                subcategories: cat.subcategories || []
              });
            });
            
            categoryDisplay = categoryArray.join(', ');
          }

          // Extract rating data
          let ratingData = {
            averageRating: 0,
            totalReviews: 0,
            workQualityRating: 0,
            behaviorRating: 0,
            personalityRating: 0
          };

          if (tech.rating) {
            ratingData = {
              averageRating: tech.rating.averageRating || 0,
              totalReviews: tech.rating.totalReviews || 0,
              workQualityRating: tech.rating.workQualityRating || 0,
              behaviorRating: tech.rating.behaviorRating || 0,
              personalityRating: tech.rating.personalityRating || 0
            };
          }

          return {
            id: tech.technician_id,
            name: tech.name || 'Unknown Technician',
            rating: ratingData.averageRating,
            totalReviews: ratingData.totalReviews,
            workQualityRating: ratingData.workQualityRating,
            behaviorRating: ratingData.behaviorRating,
            personalityRating: ratingData.personalityRating,
            skills: categoryDisplay,
            categories: categoryArray,
            subcategories: subcategoryArray,
            fullCategoryInfo: fullCategoryInfo,
            experience: tech.experience_years ? `${tech.experience_years}+ years` : `${Math.floor(Math.random() * 8) + 2}+ years`,
            price: tech.hourly_rate ? `$${tech.hourly_rate}/hr` : `$${Math.floor(Math.random() * 30) + 25}/hr`,
            jobsCompleted: tech.jobs_completed || Math.floor(Math.random() * 200) + 50,
            distance: tech.distance ? `${tech.distance} km away` : `${(Math.random() * 5 + 1).toFixed(1)} km away`,
            availability: tech.availability || (tech.availability_status === 'Available' ? ['Today', 'Tomorrow', 'Weekend'] : ['Today']),
            profile_pic: tech.profile_pic || img1,
            verified: tech.confirm_status === 'UnBlocked',
            status: tech.status,
            availability_status: tech.availability_status,
            city: tech.city,
            email: tech.email,
            mobile: tech.mobile,
            rawCategories: tech.categories || [],
            about_us: tech.about_us || '',
            address: tech.address || '',
            location: tech.location || null
          };
        });

        setTechnicians(formattedTechnicians);
      } else {
        setError('Failed to fetch technicians');
      }
    } catch (err) {
      console.error('Error fetching technicians:', err);
      setError('Failed to load technicians. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrev = () => {
    if (isMobileView) {
      scrollToSlide(currentIndex === 0 ? technicians.length - 1 : currentIndex - 1);
      return;
    }
    const maxIndex = Math.max(0, technicians.length - slidesToShow);
    setCurrentIndex((index) => (index === 0 ? maxIndex : index - 1));
  };

  const handleNext = () => {
    if (isMobileView) {
      scrollToSlide(currentIndex >= technicians.length - 1 ? 0 : currentIndex + 1);
      return;
    }
    const maxIndex = Math.max(0, technicians.length - slidesToShow);
    setCurrentIndex((index) => (index >= maxIndex ? 0 : index + 1));
  };

  const scrollToSlide = (index) => {
    const wrapper = sliderRef.current;
    const cards = wrapper?.querySelectorAll('.ts-card-link');
    const card = cards?.[index];
    if (!wrapper || !card || !cards[0]) return;
    wrapper.scrollTo({
      left: card.offsetLeft - cards[0].offsetLeft,
      behavior: 'smooth'
    });
    setCurrentIndex(index);
  };

  if (loading) {
    return (
      <section className="ts-section">
        <div className="ts-container">
          <div className="ts-header">
            <div className="ts-header-left">
              <span className="ts-badge">✦ Top Rated</span>
              <h2 className="ts-title">Top Rated Tradies Near You</h2>
              <p className="ts-subtitle">Finding the best tradies for you...</p>
            </div>
          </div>
          <div className="ts-loading">
            <div className="ts-spinner"></div>
            <p className="ts-loading-text">Loading professionals...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="ts-section">
        <div className="ts-container">
          <div className="ts-header">
            <div className="ts-header-left">
              <span className="ts-badge">✦ Top Rated</span>
              <h2 className="ts-title">Top Rated Tradies Near You</h2>
            </div>
          </div>
          <div className="ts-error">
            <p className="ts-error-msg">{error}</p>
            <button onClick={() => window.location.reload()} className="ts-retry-btn">
              Try Again
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="ts-section">
      <div className="ts-container">
        {/* Header */}
        <div className="ts-header">
          <div className="ts-header-left">
            <span className="ts-badge">✦ Top Rated</span>
            <h2 className="ts-title">Top Rated Tradies Near You</h2>
            <p className="ts-subtitle">Find trusted professionals in your area</p>
          </div>
          {!isMobileView && technicians.length > 4 && (
            <div className="ts-controls">
              <button className="ts-control-btn ts-control-prev" onClick={handlePrev} aria-label="Previous">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
              <button className="ts-control-btn ts-control-next" onClick={handleNext} aria-label="Next">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </button>
            </div>
          )}
        </div>

        {/* Slider */}
        <div
          className="ts-slider-wrapper"
          ref={sliderRef}
          onScroll={() => {
            if (!isMobileView || !sliderRef.current) return;
            const cards = sliderRef.current.querySelectorAll('.ts-card-link');
            const firstCard = cards[0];
            if (!firstCard) return;
            const gap = parseFloat(window.getComputedStyle(firstCard.parentElement).gap) || 0;
            const index = Math.round(
              (sliderRef.current.scrollLeft + firstCard.offsetLeft) / (firstCard.offsetWidth + gap)
            );
            setCurrentIndex(Math.min(index, technicians.length - 1));
          }}
        >
          <div
            className="ts-slider"
            style={{
              transform: isMobileView ? 'none' : `translateX(-${currentIndex * (100 / slidesToShow)}%)`,
              transition: 'transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)'
            }}
          >
            {technicians.map((technician) => (
              <TechnicianCard
                key={technician.id}
                technician={technician}
                style={{
                  flex: isMobileView
                    ? '0 0 min(78%, 300px)'
                    : `0 0 calc((100% - ${(slidesToShow - 1) * 24}px) / ${slidesToShow})`
                }}
              />
            ))}
          </div>
        </div>

        {Math.max(1, technicians.length - slidesToShow + 1) > 1 && (
          <div className="ts-dots">
            {Array.from({
              length: isMobileView
                ? technicians.length
                : technicians.length - slidesToShow + 1
            }).map((_, index) => (
              <button
                key={index}
                type="button"
                className={`ts-dot ${index === currentIndex ? 'ts-dot-active' : ''}`}
                onClick={() => {
                  if (isMobileView) scrollToSlide(index);
                  else setCurrentIndex(index);
                }}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}

      </div>
    </section>
  );
};

const TechnicianCard = ({ technician, style }) => {
  // Function to render star rating based on average rating
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    
    let stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push('★');
    }
    if (hasHalfStar) {
      stars.push('⭐');
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push('☆');
    }
    return stars.join('');
  };

  // Get categories and subcategories
  const getFullCategoryDisplay = () => {
    if (technician.fullCategoryInfo && technician.fullCategoryInfo.length > 0) {
      return technician.fullCategoryInfo.map(cat => ({
        name: cat.categoryName,
        subcategories: cat.subcategories.map(sub => sub.subCategoryName).filter(Boolean)
      }));
    }
    return [];
  };

  const categoryInfo = getFullCategoryDisplay();

  return (
    <Link to={`/tech-profile/${technician.id}`} state={{ technician }} className="ts-card-link" style={style}>
      <div className="ts-card">
        <div className="ts-card-image-wrapper">
          <img 
            src={technician.profile_pic || img1} 
            alt={technician.name} 
            className="ts-card-image"
            onError={(e) => { e.target.src = img1; }}
          />
          {technician.availability_status === 'Available' && (
            <span className="ts-badge-available">● Available Now</span>
          )}
          <div className="ts-card-overlay">
            <span className="ts-card-view-btn">View Profile →</span>
          </div>
        </div>
        
        <div className="ts-card-body">
          <div className="ts-card-header">
            <h3 className="ts-card-name">{technician.name}</h3>
            {technician.verified && (
              <span className="ts-badge-verified">
                <img src={img2} alt="verified" className="ts-verified-icon" /> Verified
              </span>
            )}
          </div>
          
          {/* Rating Section */}
          <p className="ts-card-rating">
            <span className="ts-stars">{renderStars(technician.rating)}</span>
            <span className="ts-rating-value">{technician.rating.toFixed(1)}</span>
            <span className="ts-rating-count">({technician.totalReviews} reviews)</span>
          </p>

          {/* Categories and Subcategories Section */}
          <div className="ts-card-categories">
            {categoryInfo.length > 0 ? (
              <div className="ts-category-container">
                {categoryInfo.map((cat, index) => (
                  <div key={index} className="ts-category-group">
                    <span className="ts-category-name">{cat.name}</span>
                    {cat.subcategories.length > 0 && (
                      <div className="ts-subcategory-tags">
                        {cat.subcategories.slice(0, 2).map((subcat, idx) => (
                          <span key={idx} className="ts-subcategory-tag">
                            {subcat}
                          </span>
                        ))}
                        {cat.subcategories.length > 2 && (
                          <span className="ts-subcategory-more">
                            +{cat.subcategories.length - 2}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <span className="ts-category-fallback">Professional Services</span>
            )}
          </div>

          {/* About/Bio Section */}
          {technician.about_us && (
            <div className="ts-about-section">
              <p className="ts-about-text">{technician.about_us}</p>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default TechnicianSlider;